<section class="cta-container">
  <app-icon [svgIcon]="'website-icon'" [class]="'cta-container__icon'"></app-icon>

  <div class="cta-container__content">
    <h2 class="body-m-bold">{{ text }}</h2>
    <a href="{{ link }}">
      <app-button
        type="primary"
        size="large"
        text="{{ btnText }}"
        icon="north_east"></app-button>
    </a>
  </div>
</section>
